<app-banner [banner]="forgotPasswordPage.banner"></app-banner>
<div id="container" class="container-fluid minHeight">
  <div>
    <div class="col-sm-12">
      <div id="rsView">
        <form id="fmadmin" class="commonFormsCss" [formGroup]="passwordResetForm" (Submit)="resetPwdSubmit()">
          <div class="row">
            <div id="loginbox" class="main-login-box middleContainer">
              <span class="text-danger h4"></span>

              <div class="brd">
                <div class="row">
                  <div class="col-sm-8 pl-10">
                    <h2>Password Reset</h2>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12" *ngIf="!passwordResetSuccess">
                    <div class="input-section">
                      <span class="control-label">eMail</span><br />
                      <input type="text" formControlName="eMail" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['eMail'].errors }" />
                      <div class="field-validation-valid text-danger" *ngIf="submitted && f['eMail'].errors && f['eMail'].errors['required']">Please enter a valid email address</div>
                      <div class="field-validation-valid text-danger" *ngIf="submitted && f['eMail'].errors && f['eMail'].errors['email']">Please enter a valid email address</div>
                    </div>
                  </div>
                  <div class="col-sm-8" *ngIf="passwordResetSuccess">
                    <div class="field-validation-valid text-danger">Please click on the reset link in the eMail we have sent to you</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12" *ngIf="!passwordResetSuccess">
                    <button role="button" type="button" (click)="resetPwdSubmit()" class="ba-btn btn-thin pull-right">Reset</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
